import { render, staticRenderFns } from "./Skenetbedrar.vue?vue&type=template&id=397ae288"
import script from "./Skenetbedrar.vue?vue&type=script&lang=js"
export * from "./Skenetbedrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports